import React from 'react'
import Navabar from './Navigation'

function Ideas() {
  return (
    <div>
      
      Ideas</div>
  )
}

export default Ideas